import React from "react";

// component
import Leftbar from "Components/Common/Leftbar";
import Header from "Components/Common/Header";

// css
import "Assets/css/style.css";
import "Assets/css/booking-form.css";
import "Assets/css/booking-list.css";
import VehicleEmissions from "Components/Core/VehicleEmissions";

const index = () => {
  return (
    <>
      <Header />
      <div id="wrapper">
        <Leftbar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <VehicleEmissions />
          </div>
        </div>
      </div>
    </>
  );
};

export default index;
